import { Empresas } from "../../models/Empresas";
import { useEffect, useState } from "react";
import { EmpresaService } from "../../service/EmpresaService";
import { InputComponent } from "../../components/InputComponent";
import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";
import { Generico } from "../../components/Generico";
import { AreaFactor } from "../matriz/AreaFactor";

export const EmpresaLista = ({toast, generic, permss, opcion, valor, catalogo}) => {

    const omodel = new Empresas();
    const [empresas, setEmpresas] = useState([]);
    const empresaService = new EmpresaService();
    const { accionesTbl } = Generico();
    const [empresa, setEmpresa] = useState(null);
    const [dialogArea, setDialogArea] = useState(false);
    const [catalogos, setCatalogos] = useState(null);
    const { table, setLoading, setTotalRecords, lazyParams} = InputComponent({ registers: empresas, omodel, generic, permss, olista: 'lista' });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);
        let _lazyParams = lazyParams;
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        empresaService.getEmpresa({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setEmpresas(res.data.registros);
            setLoading(false);
            if (res.data.perss !== undefined) {
                setCatalogos(res.data.catalogos);
            }
        });
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar && opcion === 'area')
            items.push({ label: 'Areas de negocio', icon: 'pi pi-map', command: () => { setDialogArea(true) } });

        return [{ label: 'Opciones', items: items }];
    }

    return (
        <>
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                {table({ action01: accionesTbl, reg: setEmpresa, items: itemsMenu() })}
            </Card>

            <Dialog visible={dialogArea} header={"Asignar áreas: " + empresa?.razon_social} modal className="p-fluid modal-ssize" onHide={e => setDialogArea(false)}
                style={{ maxWidth: '900px' }}>
                {<AreaFactor permss={permss} generic={generic} toast={toast} factor={valor} catalogo={catalogo} empresa={empresa} />}
            </Dialog>
        </>
    )
}
